import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { formatFlexibleDateLocale } from '../../../../utils/safe-date.util';

@Component({
    selector: 'app-regular-living-expenses-v2',
    templateUrl: './regular-living-expenses-v2.component.html',
    styleUrls: ['./regular-living-expenses-v2.component.css'],
    standalone: false
})
export class RegularLivingExpensesV2Component implements OnInit, OnChanges {

  constructor() { }

  @Input() returnData  
  @Input() printActive:boolean

  data:any;
  dateAfterSign: string
  Tax_Surcharge_Payment_and_tax_at_source:number;
  festivalSpecialExpenseComment: string;
  taxChargesComment: string;

  ngOnInit(): void {
  }
 
  ngOnChanges(){
    this.data = this.returnData?.headSummery?.expenditureSummery
    this.Tax_Surcharge_Payment_and_tax_at_source = this.data?.Tax_Charge_Payment+ this.data?.Tax_Surcharge_Payment;
    this.dateAfterSign = formatFlexibleDateLocale(this.returnData && this.returnData.submissionInfo ? this.returnData.submissionInfo.submissionDate : null, 'bn-BD');
    this.festivalSpecialExpenseComment = this.prepareCommaSeparatedString(this.data?.comments?.commentForOther, this.data?.comments?.Other_Expense)
    this.taxChargesComment = this.prepareCommaSeparatedString(this.data?.comments?.Tax_Charge_Payment, this.data?.comments?.Tax_Surcharge_Payment, this.data?.comments?.Tax_Environmental_Surcharge)
  }

  prepareCommaSeparatedString(...stringArray){
    return stringArray.filter(item=> item != '').join(',')
  }
  
}
